import api from "@/api";

export default {
    namespaced: true,
    state: {
        notifications: [],
        loading: false,
        unreadCount: 0
    },
    mutations: {
        SET_NOTIFICATIONS(state, notifications) {
            state.notifications = notifications;
            state.unreadCount = notifications.filter(n => !n.isRead).length;
        },
        ADD_NOTIFICATION(state, notification) {
            state.notifications.unshift(notification);
            state.unreadCount++;
        },
        MARK_READ(state, notificationId) {
            const notification = state.notifications.find(n => n.id === notificationId);
            if (notification && !notification.isRead) {
                notification.isRead = true;
                state.unreadCount = Math.max(0, state.unreadCount - 1);
            }
        },
        MARK_ALL_READ(state) {
            state.notifications.forEach(n => n.isRead = true);
            state.unreadCount = 0;
        },
        SET_LOADING(state, val) {
            state.loading = val;
        }
    },
    actions: {
        async fetchNotifications({ commit }) {
            commit('SET_LOADING', true);
            try {
                const res = await api.get('/notifications', { _silent: true });
                commit('SET_NOTIFICATIONS', res.data);
            } catch (error) {
                console.error("Failed to fetch notifications:", error);
            } finally {
                commit('SET_LOADING', false);
            }
        },
        addNotification({ commit }, notification) {
            commit('ADD_NOTIFICATION', notification);
        },
        async markAsRead({ commit }, notificationId) {
            try {
                await api.put(`/notifications/${notificationId}/read`, {}, { _silent: true });
                commit('MARK_READ', notificationId);
            } catch (error) {
                console.error("Failed to mark notification as read:", error);
            }
        },
        async markAllAsRead({ commit }) {
            try {
                await api.put('/notifications/mark-all-read', {}, { _silent: true });
                commit('MARK_ALL_READ');
            } catch (error) {
                console.error("Failed to mark all as read:", error);
            }
        }
    }
};
